t = require('views/internal/teacup-with-helpers')('popover_emoji_uploader')

module.exports = ->
  t.mustacheBlockInverted 'canUpload', ->

    t.div '.warning', ->

      t.mustacheBlockInverted 'hasGold', ->
        t.p ->
          t.format 'you-can-upload-custom-emoji-with-trello-gold-learn-more-about-trello-gold'

      t.mustacheBlockInverted 'hasBCGold', ->
        t.p '.u-bottom', ->
          t.format 'you-can-get-custom-emoji-for-your-entire-organization-with-business-class-learn-more-about-business-class'

    t.hr()

  t.form { action: '/1/member/' + t.mustacheVar('id') + '/customEmoji', method: 'post', enctype: 'multipart/form-data' }, ->

    t.input { type: 'hidden', name: 'token', value: '' }
    t.input { type: 'hidden', name: 'format', value: 'http' }

    t.label { for: 'emojiImage' }, ->
      t.format 'upload-image'
    t.input '.js-upload-emoji-file.upload-emoji', { id: 'emojiImage', type: 'file', name: 'file', tabindex: '-1', accept: 'image/*' }

    t.label { for: 'emojiName' }, ->
      t.format 'emoji-name'
    t.input '.js-emoji-name', { id: 'emojiName', type: 'text', name: 'name', value: t.mustacheVar('emojiName') }

    t.p '.quiet', ->
      t.format 'the-name-will-default-to-the-name-of-the-uploaded-file-you-can-change-it-here-though'

    t.p '.warning.hide.js-invalid-name', ->
      t.format 'the-emoji-name-can-only-contain-letters-numbers-and-underscores'

    t.div '.js-emoji-preview', { style: 'margin-bottom: 12px;' }, ->
      t.p { style: 'margin-bottom: 4px;' }, ->
        t.strong ->
          t.format 'preview'
      t.span '.js-emoji-preview-name', ->
        t.text t.mustacheVar('emojiName')
      t.text " → "
      t.img '.js-emoji-preview.emoji'

    t.input '.primary.wide.js-upload-emoji', { type: 'submit', value: t.l('create-custom-emoji') }

    t.div '.error.hide', ->
      t.format 'upload-failed'

  t.mustacheBlock 'canUpload', ->

    t.mustacheBlockInverted 'hasBCGold', ->
      t.hr()

      t.p '.u-bottom', ->
        t.format 'you-can-also-get-custom-emoji-for-your-entire-organization-with-business-class-learn-more-about-business-class'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_emoji_uploader.coffee